import { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../locales/messages';
import './TurbonomicROI.scss';

export interface thanksProps {
  currentNumberOnPremHosts: number;
  currentMonthtlyCloudBill: number;
  currentCostOnPremHost: number;
  annualGrowthRateOnPremVM: number;
  annualGrowthRateCloudInstance: number;
  roiValue: string;
}

const ThanksDetails = ({
  currentNumberOnPremHosts,
  currentMonthtlyCloudBill,
  currentCostOnPremHost,
  annualGrowthRateOnPremVM,
  annualGrowthRateCloudInstance,
  roiValue,
}: thanksProps): ReactElement => {
  return (
    <div className="thanks__requirement thanks__pad4">
      <FormattedMessage {...messages.totalCurrentNumberOnPremHostsTitle} />:
      <strong>{` ${currentNumberOnPremHosts}`}</strong>
      <br />
      <FormattedMessage {...messages.totalCurrentMonthtlyCloudBillTitle} />:
      <strong>{` ${currentMonthtlyCloudBill}`}</strong>
      <br />
      <FormattedMessage {...messages.TotalCurrentCostOnPremHostTilte} />:
      <strong>{` ${currentCostOnPremHost}`}</strong>
      <br />
      <FormattedMessage {...messages.annualGrowthRateOnPremVMTitle} />
      <strong>{` ${annualGrowthRateOnPremVM}%`}</strong>
      <br />
      <FormattedMessage {...messages.annualGrowthRateCloudInstanceTitle} />
      <strong>{` ${annualGrowthRateCloudInstance}%`}</strong>
      <br />
      <FormattedMessage {...messages.estimatedRoi} />:
      <strong>{` ${roiValue}`}</strong>
      <br />
    </div>
  );
};

export default ThanksDetails;
